import { ComplianceAudits } from 'src/components/ComplianceAudits/ComplianceAudits';
import { FraudPageWrapper } from 'src/layouts/FraudAndCompliancePage/FraudAndCompliancePage.style';
import { observer } from 'mobx-react-lite';
import Audits from 'src/components/Audits';
import CustomersBar from 'src/components/CustomersBar';
import FraudAndCompliance from 'src/components/FraudAndCompliance';
import Header from 'src/components/Header';
import React from 'react';
import { PepXmlRouterWrapper } from 'src/components/FraudAndCompliance/PEPTab/PEP/PepXml/PepXml';
import { AuditIdMission } from 'src/components/AuditIdMission/AuditIdMission';

export const FraudAndCompliancePage = observer(() => {
    return (
        <FraudPageWrapper>
            <Header />
            <FraudAndCompliance />
            <CustomersBar />
            <Audits />
            <ComplianceAudits />
            <AuditIdMission />
            <PepXmlRouterWrapper />
        </FraudPageWrapper>
    );
});
